/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLeadInfoRequestRace
 */
export interface CreateLeadInfoRequestRace {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    name?: string;
}

/**
 * Check if a given object implements the CreateLeadInfoRequestRace interface.
 */
export function instanceOfCreateLeadInfoRequestRace(value: object): value is CreateLeadInfoRequestRace {
    return true;
}

export function CreateLeadInfoRequestRaceFromJSON(json: any): CreateLeadInfoRequestRace {
    return CreateLeadInfoRequestRaceFromJSONTyped(json, false);
}

export function CreateLeadInfoRequestRaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadInfoRequestRace {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function CreateLeadInfoRequestRaceToJSON(json: any): CreateLeadInfoRequestRace {
    return CreateLeadInfoRequestRaceToJSONTyped(json, false);
}

export function CreateLeadInfoRequestRaceToJSONTyped(value?: CreateLeadInfoRequestRace | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

